export default __webpack_public_path__ + "static/media/home_header.c154b19e.svg";